import Image from 'app/Components/Shared/Image/image';
import React, {useState, useEffect} from 'react';
import {isMobile} from 'react-device-detect';
import {connect} from 'react-redux';
import {redirectToLogin} from '../ChangePricePlanBlock/changePricePlanSlice';
import {
  setCurrentSubscriber,
  PostCollaborationInsurance,
  GetCollaborationInsuranceData,
  IsCollaborationInsuranceAllowed,
  setNeedOtpInsurance,
} from '../CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';
import Config from '../../../Config';
import {createGuid} from '../../../utilities/StringHelpers/StringHelpers';
import OtpVerificationPageWithImage from '../../Shared/OtpAuthentication/OtpVerificationPageWithImage';
import './MainCollaborationInsurance.scss';
import BtnWhite from '../../Shared/Buttons/BtnWhite';
import {prepareUrl} from '../../../utilities/StringHelpers/StringHelpers';
import {abroadInsuranceOtpReport} from './abroadInsurancReports';
import {gaReportAbroadInsurance} from './abroadInsuranceGA';
import {abroadInsuranceEnum} from './abroadInsuranceGAEnum';
import {hideAppLoader} from '../../Shared/Loader/LoaderSlice';
import {otpOrigin} from '../OTPLoginBlock/Assets/variables';

const MainCollaborationInsurance = (props) => {
  const otpData = props.iContent?.otp?.expandedValue[0];
  const [otpStatus, setOtpStatus] = useState(null);
  const ledgertechUrl = Config.abroadInsuranceLink;
  let loginStatus = {
    isFullAuthenticated: false,
    isOtpAuthenticated: false,
    isOtpExtendedAuthenticated: false,
    token: '',
  };

  const linkPurchaseCellular = props.iContent?.linkPurchaseCellular?.value;
  let bannerSecondTitle = '';
  let bannerMainTitle = '';
  const banner = isMobile ? otpData?.imageMobile?.value : otpData?.imageDesktop?.value;
  bannerMainTitle = isMobile ? otpData?.bannerMainTitleMobile?.value : otpData?.bannerMainTitleDesktop?.value;
  bannerSecondTitle = isMobile ? otpData?.bannerSecondTitleMobile?.value : otpData?.bannerSecondTitleDesktop?.value;
  let blockSource = otpData?.blockSource?.value;

  loginStatus.isFullAuthenticated = props.authentication?.loginData?.isFullAuthenticated;
  loginStatus.isOtpAuthenticated = props.authentication?.loginData?.isOtpAuthenticated;
  loginStatus.isOtpExtendedAuthenticated = props.authentication?.loginData?.isOtpExtendedAuthenticated;
  loginStatus.token = props.authentication?.loginData?.token;

  const otpTitles = {
    verifyPhoneTitle: 'הצטרפו לביטוח נסיעות לחו"ל',
    verifyPhoneDescription: 'מה מספר הנייד שלכם?',
    phoneStepButtonText: '',
    verifyCodeTitle: '',
    verifyCodeDescription: '',
    otpCodeStepButtonText: '',
    bannerMainTitle: bannerMainTitle,
    bannerSecondTitle: bannerSecondTitle,
    blockSource: blockSource,
  };

  useEffect(() => {
    if (props.otp?.step1Ticket == '' && props.otp?.wrongOtpMessage != '') {
      setOtpStatus(false);
    }
  }, [props.otp?.wrongOtpMessage]);

  useEffect(() => {
    if (
      !props.authentication?.loginData?.isOtpAuthenticated &&
      !props.authentication?.loginData?.isFullAuthenticated &&
      !props.authentication?.loginData?.isOtpExtendedAuthenticated
    ) {
      gaReportAbroadInsurance(abroadInsuranceEnum.PhoneField);
    }

    return () => {
      props.hideAppLoader();
    };
  }, []);

  useEffect(() => {
    if (props.authentication?.loginData?.isOtpAuthenticated && props.ledgertechData?.needOTP) {
      props.setNeedOtpInsurance(false);
    }
  }, [props.ledgertechData?.needOTP, props.authentication?.loginData?.isOtpAuthenticated]);

  useEffect(() => {
    if (
      props.authentication?.loginData?.isOtpAuthenticated ||
      props.authentication?.loginData?.isFullAuthenticated ||
      props.authentication?.loginData?.isOtpExtendedAuthenticated
    ) {
      let subscriberNumber = '';
      if (props.ledgertechData?.currentSubscriber == '') {
        subscriberNumber = props.authentication?.loginData?.userDetails?.contactNumber;
      } else {
        subscriberNumber = props.ledgertechData?.currentSubscriber;
      }

      let guid = createGuid();
      let dataLedgerTech = {
        Scope: Config.siteScope,
        ClientId: Config.MezaheBituahC,
        ClientSecret: Config.MezaheBituah,
        LoginType: 'CREDENTIALS',
        Sid: guid,
        SubscriberNumber: subscriberNumber,
      };

      props.PostCollaborationInsurance(dataLedgerTech).then((res) => {
        if (!res?.payload?.error) {
          let url = decodeURI(ledgertechUrl);
          url = url.replace('{0}', res?.payload?.data);
          window.open(url, '_self');
        } else {
          let url = decodeURI(ledgertechUrl);
          url = url.replace('{0}', 'null');
          window.open(url, '_self');
        }
      });
    }
  }, [
    props.authentication?.loginData?.isOtpAuthenticated,
    props.authentication?.loginData?.isFullAuthenticated,
    props.authentication?.loginData?.isOtpExtendedAuthenticated,
  ]);

  useEffect(() => {
    if (otpStatus != null && !otpStatus) {
      abroadInsuranceOtpReport('Completed', 'No Cellcom Subscription Displayed', '', 'No Cellcom Subscription');
      gaReportAbroadInsurance(abroadInsuranceEnum.CellocmCusOffer);
    }
  }, [otpStatus]);

  if (otpStatus != null && !otpStatus) {
    return (
      <>
        <div className='error-page'>
          <div className='error-img'>
            <Image src={require('./images/error-logo.svg')} alt='phone-icon' />
          </div>
          <div className='error-msg'>
            <div>אופס...</div>
            <div>ההצעה לביטוח היא בלעדית</div>
            <div>ללקוחות הסלולר של {window.Config.brand_Name_HE}</div>
          </div>

          <div>
            <a
              className='join-btn'
              onClick={() => {
                prepareUrl(linkPurchaseCellular, props.context),
                  abroadInsuranceOtpReport('Ongoing', 'Join Cellcom Button Clicked', '', 'No Cellcom Subscription'),
                  gaReportAbroadInsurance(abroadInsuranceEnum.CellocmCustomerOfferJoinButton);
              }}>
              רוצים להצטרף?
            </a>
          </div>
          <BtnWhite style={{height: '50px'}} className='h-50' text={'לעמוד הבית'} onclick={() => prepareUrl('', props.context)} />
        </div>
      </>
    );
  }

  if (
    (!props.authentication?.loginData?.isOtpAuthenticated &&
      !props.authentication?.loginData?.isFullAuthenticated &&
      !props.authentication?.loginData?.isOtpExtendedAuthenticated) ||
    ((props.authentication?.loginData?.isFullAuthenticated || props.authentication?.loginData?.isOtpExtendedAuthenticated) &&
      props.ledgertechData?.currentSubscriber == '' &&
      otpStatus != null &&
      !otpStatus)
  ) {
    props.setNeedOtpInsurance(true);
    return (
      <div className='collaboration-insurance'>
        <OtpVerificationPageWithImage
          otpOrigin={otpOrigin.GENERIC}
          originProcess={otpTitles.blockSource}
          otpTitles={otpTitles}
          isInline={false}
          otpBanner={banner}
        />
      </div>
    );
  } else {
    if (otpStatus != null && !otpStatus) {
      return (
        <>
          <div className='error-page'>
            <div className='error-img'>
              <Image src={require('./images/error-logo.svg')} alt='phone-icon' />
            </div>
            <div className='error-msg'>
              <div>אופס...</div>
              <div>ההצעה לביטוח היא בלעדית</div>
              <div>ללקוחות הסלולר של {window.Config.brand_Name_HE}</div>
            </div>

            <div>
              <a
                className='join-btn'
                onClick={() => {
                  prepareUrl(linkPurchaseCellular, props.context),
                    gaReportAbroadInsurance(abroadInsuranceEnum.CellocmCustomerOfferJoinButton);
                }}>
                רוצים להצטרף?
              </a>
            </div>
            <BtnWhite style={{height: '50px'}} className='h-50' text={'לעמוד הבית'} onclick={() => prepareUrl('', props.context)} />
          </div>
        </>
      );
    }

    return <div></div>;
  }
};

const mapStateToProps = (state) => {
  return {
    authentication: state.authentication,
    ledgertechData: state.cellcomAbroad.abroadInsurance,
    insuranceData: state.cellcomAbroad.abroadPermanentInsuranceSocData,
    otp: state.otpAuthentication,
  };
};

const mapDispatchToProps = {
  redirectToLogin,
  PostCollaborationInsurance,
  GetCollaborationInsuranceData,
  IsCollaborationInsuranceAllowed,
  setCurrentSubscriber,
  setNeedOtpInsurance,
  hideAppLoader,
};
export default connect(mapStateToProps, mapDispatchToProps)(MainCollaborationInsurance);
